exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.spinner *[data-v-7698009d] {\n  line-height: 0;\n  box-sizing: border-box;\n}\n.spinner > div[data-v-7698009d] {\n  background-color: transparent;\n  border: 1px solid #41b883;\n  border-radius: 100%;\n  animation-fill-mode: both;\n  position: absolute;\n  opacity: 0;\n  width: 50px;\n  height: 50px;\n  animation: wave-jumper-data-v-7698009d 1s 0s linear infinite;\n}\n.spinner > div[data-v-7698009d]:nth-child(2) {\n  animation-delay: 0.33333s;\n}\n.spinner > div[data-v-7698009d]:nth-child(3) {\n  animation-delay: 0.66666s;\n}\n@keyframes wave-jumper-data-v-7698009d {\n0% {\n    opacity: 0;\n    transform: scale(0);\n}\n5% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7698009d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loading-spinner/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-loading-spinner/src/components/Wave.vue
// module id = 456
// module chunks = 2